/**
 * Collection HTML can stay stale for hours after a product save.
 * Re-read colors from /products/handle.js so swatches show immediately.
 */
(function () {
  var COLOR_NAMES = /(colo|لون)/i;
  var SWATCH_CLASS =
    'inline-block w-5 h-5 rounded-full border-2 border-white ring-1 ring-[#ccc] cursor-pointer transition-all duration-200 hover:ring-2 hover:ring-[#1b1c1c] hover:ring-offset-1';

  function productJsUrl(handle) {
    var path = '/products/' + encodeURIComponent(handle) + '.js';
    if (window.__giraffeCartApiUrl) return window.__giraffeCartApiUrl(path);
    return path;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function colorOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i += 1) {
      var name = typeof opts[i] === 'string' ? opts[i] : (opts[i] && opts[i].name) || '';
      if (COLOR_NAMES.test(String(name).trim())) return i;
    }
    return -1;
  }

  function uniqueColors(product, index) {
    var opt = product.options && product.options[index];
    if (opt && opt.values && opt.values.length) return opt.values.slice();
    var values = [];
    var seen = {};
    var key = 'option' + (index + 1);
    (product.variants || []).forEach(function (variant) {
      var value = variant[key];
      if (value && !seen[value]) {
        seen[value] = true;
        values.push(value);
      }
    });
    return values;
  }

  function cssColor(name) {
    return String(name || '').toLowerCase().replace(/\s+/g, '').replace(/\//g, '');
  }

  function variantImage(product, colorIndex, colorValue) {
    var key = 'option' + (colorIndex + 1);
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i += 1) {
      var image = variants[i].featured_image;
      if (variants[i][key] === colorValue && image && image.src) return image.src;
    }
    return '';
  }

  function swatchPrefix(card) {
    return card.classList.contains('bs-card') ? 'bs-swatch ' : 'cp-swatch ';
  }

  function renderSwatches(mount, product, card) {
    var index = colorOptionIndex(product);
    if (index < 0) {
      mount.innerHTML = '';
      mount.hidden = true;
      return;
    }
    var colors = uniqueColors(product, index);
    if (!colors.length) {
      mount.innerHTML = '';
      mount.hidden = true;
      return;
    }
    var extra = colors.length > 5 ? colors.length - 5 : 0;
    var html = '';
    var cls = swatchPrefix(card) + SWATCH_CLASS;
    colors.slice(0, 5).forEach(function (color) {
      html +=
        '<span title="' +
        escapeHtml(color) +
        '" class="' +
        cls +
        '" style="background-color: ' +
        cssColor(color) +
        ';" data-swatch-img="' +
        escapeHtml(variantImage(product, index, color)) +
        '"></span>';
    });
    if (extra) {
      html += '<span class="text-[9px] text-secondary leading-5">+' + extra + '</span>';
    }
    mount.innerHTML = html;
    mount.hidden = false;
  }

  function bindHover(card) {
    var img = card.querySelector('[data-cp-img], [data-bs-img]');
    if (!img) return;
    var originalSrc = img.getAttribute('src');
    var originalSrcset = img.getAttribute('srcset') || '';
    card.querySelectorAll('.cp-swatch, .bs-swatch').forEach(function (swatch) {
      var src = swatch.getAttribute('data-swatch-img');
      if (src) {
        var preload = new Image();
        preload.src = src;
      }
      if (!src) return;
      swatch.addEventListener('mouseenter', function () {
        img.setAttribute('srcset', '');
        img.setAttribute('src', src);
      });
      swatch.addEventListener('mouseleave', function () {
        img.setAttribute('src', originalSrc);
        if (originalSrcset) img.setAttribute('srcset', originalSrcset);
      });
    });
  }

  function hydrateCard(card) {
    var handle = card.getAttribute('data-product-handle');
    var mount = card.querySelector('[data-product-swatches]');
    if (!handle || handle === 'giraffe-gift-cards' || !mount) {
      if (card.getAttribute('data-swatches-bound') !== 'true') {
        card.setAttribute('data-swatches-bound', 'true');
        bindHover(card);
      }
      return;
    }
    if (card.getAttribute('data-swatches-hydrating') === 'true') return;
    card.setAttribute('data-swatches-hydrating', 'true');

    fetch(productJsUrl(handle), { credentials: 'same-origin', cache: 'no-cache' })
      .then(function (res) {
        if (!res.ok) throw new Error('product.js ' + res.status);
        return res.json();
      })
      .then(function (product) {
        renderSwatches(mount, product, card);
        card.setAttribute('data-swatches-bound', 'true');
        bindHover(card);
      })
      .catch(function () {
        if (card.getAttribute('data-swatches-bound') !== 'true') {
          card.setAttribute('data-swatches-bound', 'true');
          bindHover(card);
        }
      });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-product-handle]').forEach(hydrateCard);
  }

  window.__giraffeHydrateCardSwatches = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
